import { MapPin } from 'lucide-react';

/**
 * Bouton Google Maps — ouvre l'adresse dans Google Maps.
 * Usage: <GoogleMapsBtn address="123 Rue Main" ville="Montréal" codePostal="H1A 1A1" />
 */
export function GoogleMapsBtn({ address, ville, codePostal, className = '', size = 'sm', label = true }) {
  const fullAddress = [address, ville, codePostal, 'Québec, Canada'].filter(Boolean).join(', ');

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const encoded = encodeURIComponent(fullAddress);
    window.open(`https://www.google.com/maps/search/?api=1&query=${encoded}`, '_blank', 'noopener,noreferrer');
  };

  if (!address && !ville) return null;

  return (
    <button
      onClick={handleClick}
      title={`Ouvrir dans Google Maps : ${fullAddress}`}
      data-testid="google-maps-btn"
      className={`inline-flex items-center gap-1 text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded px-1.5 py-0.5 transition-colors shrink-0 ${className}`}
    >
      <MapPin className={size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4'} />
      {label && <span className={size === 'sm' ? 'text-xs font-medium' : 'text-sm font-medium'}>Maps</span>}
    </button>
  );
}
